import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe that safely formats date strings in history logs.
 * If the value is a valid ISO date string, it formats it using Angular's DatePipe.
 * Otherwise, it returns the original value untouched.
 *
 * @usage
 * {{ data | formatHistoryDate }}
 * {{ data | formatHistoryDate:'MMM dd yyyy' }}
 */
@Pipe({
  name: 'formatHistoryDate',
  standalone: false,
})
export class FormatHistoryDatePipe implements PipeTransform {
  private readonly _datePipe: DatePipe;

  constructor(@Inject(LOCALE_ID) locale: string) {
    this._datePipe = new DatePipe(locale);
  }

  transform(value: unknown, format = 'MMM dd yyyy h:mm a'): unknown {
    if (this._isDateString(value)) {
      return this._datePipe.transform(value, format) || value;
    }
    return value;
  }

  private _isDateString(value: unknown): value is string {
    return (
      typeof value === 'string' &&
      !!value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)
    );
  }
}
